export default __webpack_public_path__ + "static/media/330_dummy2016-weinhandel01-mobile-de.1449a071.png";